import React from 'react';
import { bool, number, string, oneOfType, oneOf } from 'prop-types';
import cx from 'classnames';

import { getResponsivePropType, genResponsiveClasses } from './../../utils/';

const propTypes = {
  /** Html element. */
  tag: string,
  /** Column size. Number, 'shrink/fill/auto', or responsive map */
  size: getResponsivePropType(
    oneOfType([number, oneOf(['shrink', 'fill', 'auto', 'fixed'])])
  ),
  equalizeHeight: bool,
};

const CLASS_ROOT = 'grid__col';

const GridCol = ({
  className,
  tag = 'div',
  size,
  equalizeHeight,
  ...other
}) => {
  const classes = cx(
    !size && CLASS_ROOT,
    ...genResponsiveClasses(CLASS_ROOT, size),
    {
      [`${CLASS_ROOT}--equalized`]: equalizeHeight,
    },
    className
  );

  const TagName = tag;

  return <TagName className={classes} {...other} />;
};

GridCol.displayName = 'GridCol';
GridCol.propTypes = propTypes;

export default GridCol;



// WEBPACK FOOTER //
// ./src/components/Grid/GridCol.js